import { Controller } from '@hotwired/stimulus';

// Past trackpad jitter and browser scroll restoration, well under the fold.
const HIDE_PX = 24;
// Only a true return to the top brings it back; the gap to HIDE_PX is what stops it flickering.
const SHOW_PX = 1;

const HIDDEN_CLASS = 'landing-fold-cue-hidden';

// Fades the hero fold's "How it Works" cue out as soon as the page moves, so it is never on screen
// beside the title it names, and back in only once the fold is whole again. Deliberately runs under
// reduced motion too — a crossfade is not motion, and it is all that keeps those visitors from
// seeing the title twice.
export default class extends Controller {
  connect() {
    this.__onScroll = () => {
      if (window.scrollY > HIDE_PX) this.element.classList.add(HIDDEN_CLASS);
      else if (window.scrollY <= SHOW_PX) this.element.classList.remove(HIDDEN_CLASS);
    };

    window.addEventListener('scroll', this.__onScroll, { passive: true });
    this.__onScroll();
  }

  disconnect() {
    window.removeEventListener('scroll', this.__onScroll);
    this.element.classList.remove(HIDDEN_CLASS);
  }
}
